import { ApiMessageType } from '../api_message_types'
import Service from './service'
/**
 * Сервис для сканирования паспортов
 * @version 0.0.1
 * @since 1.9.1
 */
export default class PromobotPassportScannerService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiMessageType.SCANNER_PASSPORT_RESPONSE:
          delete message.id
          delete message.type
          if (message.success && message.success === true) {
            this.resolve(this.waiters.scan)
          }
          else {
            this.reject(this.waiters.scan)
          }
          break
        case ApiMessageType.SCANNER_PASSPORT_ERROR:
          delete message.id
          delete message.type
          // if (this.scanPassportErrorCallback) {
          //   this.scanPassportErrorCallback(message)
          // }
          break
        case ApiMessageType.SCANNER_PASSPORT_STATE:
          delete message.id
          delete message.type
          // if (this.scanPassportStateCallback) {
          //   this.scanPassportStateCallback(message)
          // }
          break
        case ApiMessageType.SCANNER_PASSPORT_FINISH:
          delete message.id
          delete message.type
          // if (this.scanPassportFinishCallback && message.data) {
          //   this.scanPassportFinishCallback(message.data)
          // }
          break
      }
    }
    this.waiters = {
      scan: [],
    }
    this.messageChannel.subscribe(ApiMessageType.SCANNER_PASSPORT_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.SCANNER_PASSPORT_ERROR, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.SCANNER_PASSPORT_STATE, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.SCANNER_PASSPORT_FINISH, messageHandler)
  }
  /**
     * Произошла ошибка при сканировании
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>произошла ошибка при сканировании</caption>
     * robot.passportScannerService.onScanPassportError(() => {
     *   ...
     * })
     */
  onScanPassportError(_callback) {
    // this.scanPassportErrorCallback = callback
  }
  /**
     * Сканирование документа завершилось
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>сканирование документа завершилось</caption>
     * robot.passportScannerService.onScanPassportFinish(() => {
     *   ...
     * })
     */
  onScanPassportFinish(_callback) {
    // this.scanPassportFinishCallback = callback
  }
  /**
     * Изменилось состояние сканера
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>изменилось состояние сканера</caption>
     * robot.passportScannerService.onScanPassportState(() => {
     *   ...
     * })
     */
  onScanPassportState(_callback) {
    // this.scanPassportStateCallback = callback
  }
  /**
     * Сканировать паспорт
     * @since 1.9.1
     * @param {boolean} ignoreNotConnected - игнорировать статус подключения
     * @param {Number} timeout - сколько времени сканер будет ждать пока к нему что-то приложат (по умолчанию 30 сек)
     * @return {Promise}
     *
     * @example <caption>изменилось состояние сканера</caption>
     * robot.passportScannerService.scanPassport(() => {
     *   ...
     * })
     */
  scanPassport(ignoreNotConnected = false, timeout = 30) {
    return this.execute({
      type: ApiMessageType.SCANNER_PASSPORT_REQUEST,
      ignore_not_connected: ignoreNotConnected,
      timeout,
    }, this.waiters.passportScan)
  }
}
